// src/utils/questionnaireQuestions/actQuestionnaire.js
// Asthma Control Test (ACT)
// Scale: 0 = worst • 4 = best. Sum (0-20).

const actQuestionnaire = [
  /* 1 - Work, school, or home impact */
  {
    id: "actWorkSchoolHome",
    titleKey: "actWorkSchoolHome.title",
    rangeDescriptionKey: "actWorkSchoolHome.rangeDesc",
    fieldType: "range",
    required: true,
    min: 0,
    max: 4,
    step: 1,
    title:
      "During the last 4 weeks, how much of the time has your asthma kept you from getting as much done at work, school or home?",
    rangeDescription:
      "0 = All of the time\n1 = Most of the time\n2 = Some of the time\n3 = A little of the time\n4 = None of the time",
    group: "act",
  },

  /* 2 - Shortness of breath frequency */
  {
    id: "actShortnessOfBreath",
    titleKey: "actShortnessOfBreath.title",
    rangeDescriptionKey: "actShortnessOfBreath.rangeDesc",
    fieldType: "range",
    required: true,
    min: 0,
    max: 4,
    step: 1,
    title:
      "During the last 4 weeks, how often have you had shortness of breath?",
    rangeDescription:
      "0 = More than once a day\n1 = Once a day\n2 = 3 to 6 times a week\n3 = Once or twice a week\n4 = Not at all",
    group: "act",
  },

  /* 3 - Night symptoms */
  {
    id: "actNightSymptoms",
    titleKey: "actNightSymptoms.title",
    rangeDescriptionKey: "actNightSymptoms.rangeDesc",
    fieldType: "range",
    required: true,
    min: 0,
    max: 4,
    step: 1,
    title:
      "During the last 4 weeks, how often have your asthma symptoms (wheezing, coughing, shortness of breath, chest tightness or pain) woken you up at night or earlier than usual in the morning?",
    rangeDescription:
      "0 = 4 or more nights a week\n1 = 2 to 3 nights a week\n2 = Once a week\n3 = Once or Twice\n4 = Not at all",
    group: "act",
  },

  /* 4 - Rescue inhaler use */
  {
    id: "actRescueInhalerUse",
    titleKey: "actRescueInhalerUse.title",
    rangeDescriptionKey: "actRescueInhalerUse.rangeDesc",
    fieldType: "range",
    required: true,
    min: 0,
    max: 4,
    step: 1,
    title:
      "During the last 4 weeks, how often have you used your rescue inhaler or nebuliser medication (such as salbutamol)?",
    rangeDescription:
      "0 = 3 or more times per day\n1 = Once or twice per day\n2 = 2 or 3 times per week\n3 = Once a week or less\n4 = Not at all",
    group: "act",
  },

  /* 5 - Overall asthma control */
  {
    id: "actAsthmaControl",
    titleKey: "actAsthmaControl.title",
    rangeDescriptionKey: "actAsthmaControl.rangeDesc",
    fieldType: "range",
    required: true,
    min: 0,
    max: 4,
    step: 1,
    title: "How would you rate your asthma control during the last 4 weeks?",
    rangeDescription:
      "0 = Not Controlled at all\n1 = Poorly Controlled\n2 = Somewhat Controlled\n3 = Well Controlled\n4 = Completely Controlled",
    group: "act",
  },
];

actQuestionnaire.metadata = {
  titleKey: "title",
  title: "Asthma Control Test (ACT)",
  introKey: "intro",
};

export default actQuestionnaire;
